<template>
  <div>
    <div v-if="list.length || sponsor.length">
      <ul class="tabs">
        <li v-for="(item, index) in list" :key="index" class="tab">
          <div>
            <iain-image-domain w="90" h="90" r="10" :src="item.logo" />
          </div>
          <div class="tab-label">{{ item.name }}</div>
        </li>
      </ul>

      <div class="swiper-container">
        <van-swipe class="swiper" vertical :autoplay="3000" :show-indicators="false" :touchable="false" :height="height">
          <van-swipe-item v-for="(item, index) in _sponsor" :key="index" class="swiper-item">
            <span>{{ item.name }}赞助</span>
            <span class="swiper-item-amount">{{ $lodash.formatThousandMark(item.amount / 100) }}</span>
            <span>元</span>

            <!-- van ui 不支持 swipe-item 高度自定义后使用 loop -->
            <div v-if="index === _sponsor.length - 1" class="swiper-item-mend">
              <div v-for="(mend, mendIndex) in _sponsorMend" :key="mendIndex" class="swiper-item">
                <span>{{ mend.name }}赞助</span>
                <span class="swiper-item-amount">{{ $lodash.formatThousandMark(mend.amount / 100) }}</span>
                <span>元</span>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div v-else>
      <iain-gap height="20" />
      <van-empty class="custom mini" description="暂无团队赞助" />
    </div>
  </div>
</template>

<script>
import getTargetSwipes from './getTargetSwipes'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    sponsor: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    height() {
      return Math.ceil(0.6 * window.rem)
    },

    _sponsor() {
      return getTargetSwipes(this.sponsor)
    },

    _sponsorMend() {
      const [first, second, thirdly] = this._sponsor
      return [second, thirdly]
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  padding: 30px 0 20px;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;

  .tab {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;

    .tab-label {
      padding-top: 20px;
      width: 138px;
      font-size: 24px;
      color: #666666;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.swiper-container {
  padding: 8px 30px;

  .swiper {
    height: 180px;

    .swiper-item {
      position: relative;
      height: 60px;
      line-height: 60px;

      .swiper-item-amount {
        color: #ff5500;
        margin: 0 10px;
      }

      .swiper-item-mend {
        position: absolute;
        top: 120px;
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>
